import gql from 'graphql-tag';

export const getServiceRequestContentId = gql`
  query getServiceRequestContentId($channelId: UUID!) {
    serviceRequestContentId(channelId: $channelId)
  }
`;
